export function get(item, prop, defaultValue) {
  if (!item) {
    return defaultValue;
  }
  if (typeof item.get === 'function') {
    return item.get(prop) == null ? defaultValue : item.get(prop);
  }
  return item[prop] == null ? defaultValue : item[prop];
}

export function has(item, prop) {
  if (!item) {
    return false;
  }
  if (typeof item.has === 'function') {
    return item.has(prop);
  }
  return prop in item;
}

export function size(item) {
  if (!item) {
    return undefined;
  }
  if (typeof item.size === 'number') {
    return item.size;
  }
  return item.length;
}
